/**
 * First letter of the first two words, uppercased — "Diana Bell" → "DB",
 * "Diana" → "D", `undefined` / blank → "". Usernames render as "@handle"
 * product-wide, so a leading `@` is stripped first ("@marco" → "M").
 * Spread-based first-char so surrogate-pair initials (emoji, CJK-adjacent
 * scripts) don't split.
 *
 * Pure and dependency-free, beside `avatarColors` — the other half of what the
 * Avatar derives from a name. Kept OUT of `Avatar.tsx` so callers that only
 * need the string (identity helpers and their specs) don't pull the React
 * render chain in with it.
 */
export function initialsFor(name: string | undefined): string {
  if (!name) return '';
  return name
    .trim()
    .replace(/^@/, '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => [...word][0]!.toUpperCase())
    .join('');
}
